import { render, staticRenderFns } from "./headerNew.pc.vue?vue&type=template&id=9c0509ec"
import script from "./headerNew.pc.vue?vue&type=script&lang=js"
export * from "./headerNew.pc.vue?vue&type=script&lang=js"
import style0 from "./headerNew.pc.vue?vue&type=style&index=0&id=9c0509ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports